<template>
  <div class="container mx-auto">
    <div class="mb-6">
      <div class="flex justify-between mb-4">
        <div class="flex-1 min-w-0">
          <router-link :to="{ name: 'empleado-descuentos', params: { id: this.$route.params.id, nombreempleado: this.$route.params.nombreempleado } }" class="inline-flex text-gray-700 hover:text-gray-900 border px-4 py-1 rounded text-xs border-gray-600 hover:bg-gray-300">Regresar</router-link>
        </div>
        <div class="flex">
          <span class="px-4 text-xs font-medium text-gray-800 bg-gray-200 border rounded-md border-transparent py-1">{{ this.$route.params.nombreempleado }}</span>
        </div>
      </div>
    </div>
    <div class="grid grid-cols-1 gap-6 mb-10">
      <div class="mt-5 md:mt-0 md:col-span-2">
        <form @submit.prevent="createDescuento">
          <div class="shadow sm:rounded-md">
            <div class="px-4 py-5 bg-white sm:p-6">
              <div class="grid grid-cols-12 gap-6 mb-6">
                <div class="col-span-12">
                  <p class="uppercase text-base text-gray-700 font-medium tracking-wider">Nuevo Descuento</p>
                </div>
              </div>
              <div class="grid grid-cols-12 gap-6 mb-6">
                <div class="col-span-3">
                  <label class="block text-sm leading-5 text-gray-700">Categoria</label>
                  <select v-model="categoria" class="mt-1 block form-select w-full py-2 px-3 border border-gray-400 bg-white rounded shadow-sm focus:outline-none text-xs">
                    <option>Multa</option>
                    <option>Corte</option>
                    <option>Inventario</option>
                  </select>
                </div>
                <div class="col-span-3">
                  <label class="block text-sm leading-5 text-gray-700">Monto</label>
                  <input v-model="monto" required class="mt-1 form-input block w-full py-1 px-3 border border-gray-400 rounded shadow-sm text-sm leading-6 focus:outline-none" placeholder="0.00">
                </div>
              </div>
              <div class="grid grid-cols-12 gap-6 mb-6">
                <div class="col-span-6">
                  <label class="block text-sm leading-5 text-gray-700">Motivo</label>
                  <textarea v-model="motivo" rows="3" size="200" maxlength="200" class="mt-1 form-textarea block w-full py-1 px-3 border border-gray-400 rounded shadow-sm text-sm leading-6 focus:outline-none resize-none"></textarea>
                </div>
              </div>
              <div class="grid grid-cols-12 gap-6 mb-6">
                <div class="col-span-4">
                  <label class="block text-sm leading-5 text-gray-700">Semana de Descuento</label>
                  <select v-model="semana" class="mt-1 block form-select w-full py-2 px-3 border border-gray-400 bg-white rounded shadow-sm focus:outline-none text-xs">
                    <option v-for="(item, key) in semanas" :value="item.id" :key="key">Sem: {{item.semana}} ({{item.fecha_inicial | moment("DD MMM YYYY")}} - {{item.fecha_final | moment("DD MMM YYYY")}})</option>
                  </select>
                </div>
              </div>
              <button class="py-1 px-4 border border-transparent text-sm leading-5 rounded text-white bg-green-500 hover:bg-green-600 focus:outline-none">
                Registrar Descuento
              </button>
              <span v-show="errorCaptura" class="text-red-600 text-sm ml-6">Error al registrar descuento, verificar datos.</span>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import authClient from '@/utils/auth'
export default {
  name: 'NuevoDescuento',
  data () {
    return {
      categoria: 'Multa',
      monto: '',
      motivo: '',
      semana: 1,
      semanas: [],
      errorCaptura: false
    }
  },
  methods: {
    obtenerSemanas () {
      this.$http.post('/api/semanas/semanas-activas')
        .then(({ data }) => {
          if (data.length > 0) {
            this.semanas = data.reverse()
            this.semana = data[0].id
          }
        })
    },
    createDescuento () {
      const descuentoObject = {
        tipo: this.tipoDescuento,
        categoria: this.categoria,
        monto: this.monto,
        motivo: this.motivo,
        empleadoId: this.$route.params.id,
        semanaId: this.semana
      }
      this.$http.post('/api/exp-descuento', descuentoObject, {
        headers: { Authorization: authClient.getAuthToken() }
      })
        .then(() => this.$router.push({ name: 'empleado-descuentos', params: { id: this.$route.params.id, nombreempleado: this.$route.params.nombreempleado } }))
        .catch(() => {
          this.errorCaptura = true
          setTimeout(() => (this.errorCaptura = false), 5000)
        })
    }
  },
  computed: {
    tipoDescuento: {
      get () {
        let tipo = 1
        switch (this.categoria) {
          case 'Multa':
            tipo = 1
            break
          case 'Corte':
            tipo = 2
            break
          case 'Inventario':
            tipo = 3
            break
          default:
            break
        }
        return tipo
      }
    }
  },
  mounted () {
    this.obtenerSemanas()
  }
}
</script>
